"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnConfigs = exports.employeeDisplayProperties = void 0;
const model_1 = require("../model");
const utils_1 = require("../utils");
exports.employeeDisplayProperties = [
    // employee core data fields
    "fullName",
    "fullId",
    "lastName",
    "firstName",
    "timePin",
    "callName",
    "address",
    "city",
    "postalCode",
    "staffNumber",
    "email",
    "phone",
    "phone2",
    "notes",
    "birthday",
    "birthName",
    "birthCity",
    "birthCountry",
    "nationality",
    "gender",
    "taxId",
    "socialSecurityNumber",
    // contract fields
    "employmentType",
    "nominalWeeklyHours",
    "vacationDays",
    "defaultSalary",
    "contract_end",
    "employedDays",
    "bonuses",
    "benefits",
    // time report fields,
    "timeReportDays",
    "timeReportHours",
    "vacationReportDays",
    "vacationReportHours",
    "sickReportDays",
    "sickReportHours",
    // time balance fields
    "timeBalanceCarry",
    "timeBalanceNominal",
    "timeBalanceActual",
    "timeBalanceDifference",
    "timeBalanceBalance",
    // vacation balance fields
    "vacationBalanceCarry",
    "vacationBalanceNominal",
    "vacationBalanceActual",
    "vacationBalanceDifference",
    "vacationBalanceBalance",
    // bonus balance fields
    "bonusesBalanceCarry",
    "bonusesBalanceNominal",
    "bonusesBalanceActual",
    "bonusesBalanceDifference",
    "bonusesBalanceBalance",
];
exports.columnConfigs = {
    // Employee core date fields
    fullName: {
        getHeader: () => "Voller Name",
        getValue: ({ employee }) => `${employee.lastName}, ${employee.firstName}`,
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    fullId: {
        getHeader: () => "Voller Name + Pers-Nr.",
        getValue: ({ employee }) => { var _a; return `${employee.lastName}, ${employee.firstName} #${((_a = employee.staffNumber) === null || _a === void 0 ? void 0 : _a.toString()) || ""}`; },
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    firstName: {
        getHeader: () => "Vorname",
        getValue: ({ employee }) => employee.firstName,
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    lastName: {
        getHeader: () => "Nachname",
        getValue: ({ employee }) => employee.lastName,
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    staffNumber: {
        getHeader: () => "Pers-Nr.",
        getValue: ({ employee }) => { var _a; return ((_a = employee.staffNumber) === null || _a === void 0 ? void 0 : _a.toString()) || ""; },
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    timePin: {
        getHeader: () => "Zeit-PIN",
        getValue: ({ employee }) => employee.timePin || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    callName: {
        getHeader: () => "Rufname",
        getValue: ({ employee }) => employee.callName || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    address: {
        getHeader: () => "Adresse",
        getValue: ({ employee }) => employee.address || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    city: {
        getHeader: () => "Stadt",
        getValue: ({ employee }) => employee.city || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    postalCode: {
        getHeader: () => "PLZ",
        getValue: ({ employee }) => employee.postalCode || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    email: {
        getHeader: () => "E-Mail",
        getValue: ({ employee }) => employee.email || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    phone: {
        getHeader: () => "Telefon",
        getValue: ({ employee }) => employee.phone || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    phone2: {
        getHeader: () => "Telefon 2",
        getValue: ({ employee }) => employee.phone2 || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    notes: {
        getHeader: () => "Notizen",
        getValue: ({ employee }) => employee.notes || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    birthday: {
        getHeader: () => "Geburtstag",
        getValue: ({ employee }) => (employee.birthday ? (0, utils_1.formatDate)(employee.birthday) : ""),
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    birthName: {
        getHeader: () => "Geburtsname",
        getValue: ({ employee }) => employee.birthName || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    birthCity: {
        getHeader: () => "Geburtsort",
        getValue: ({ employee }) => employee.birthCity || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    birthCountry: {
        getHeader: () => "Geburtsland",
        getValue: ({ employee }) => employee.birthCountry || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    nationality: {
        getHeader: () => "Nationalität",
        getValue: ({ employee }) => employee.nationality || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    gender: {
        getHeader: () => "Geschlecht",
        getValue: ({ employee }) => employee.gender || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    taxId: {
        getHeader: () => "Steuernummer",
        getValue: ({ employee }) => employee.taxId || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    socialSecurityNumber: {
        getHeader: () => "Sozialversicherungsnummer",
        getValue: ({ employee }) => employee.socialSecurityNumber || "",
        requiredPermissions: ["manage.employees.core_data"],
        requiredContext: ["employee"],
    },
    // contract fields
    employmentType: {
        getHeader: () => "Besch.verh.",
        getValue: ({ employee }) => {
            var _a;
            const employmentType = (_a = employee.currentContract) === null || _a === void 0 ? void 0 : _a.employmentType;
            return employmentType != null ? (0, model_1.employmentTypeLabel)(employmentType) : "";
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    nominalWeeklyHours: {
        getHeader: () => "Sollstunden (pro Woche)",
        getValue: ({ employee }) => {
            var _a;
            const nominalWeeklyHours = (_a = employee.currentContract) === null || _a === void 0 ? void 0 : _a.nominalWeeklyHours;
            return nominalWeeklyHours != null ? (0, utils_1.formatNumber)(nominalWeeklyHours) : "";
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    vacationDays: {
        getHeader: () => "Urlaubsanspr. (Tage / Jahr)",
        getValue: ({ employee }) => {
            var _a;
            const vacationDays = (_a = employee.currentContract) === null || _a === void 0 ? void 0 : _a.vacationDays;
            return vacationDays != null ? (0, utils_1.formatNumber)(vacationDays) : "";
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    defaultSalary: {
        getHeader: () => "Lohn / Gehalt",
        getValue: ({ employee }) => {
            var _a;
            const defaultSalary = (_a = employee.currentContract) === null || _a === void 0 ? void 0 : _a.defaultSalary;
            if (defaultSalary == null) {
                return "";
            }
            return defaultSalary.type === "monthly"
                ? `${(0, utils_1.formatNumber)(defaultSalary.amount)} € / Mon`
                : `${(0, utils_1.formatNumber)(defaultSalary.amount)} € / Std`;
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    contract_end: {
        getHeader: () => "Vertragsende",
        getValue: ({ employee }) => {
            var _a;
            const latestEnd = (_a = employee.latestContract) === null || _a === void 0 ? void 0 : _a.end;
            return latestEnd ? (0, utils_1.formatDate)(latestEnd) : "Unbefristet";
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    employedDays: {
        getHeader: () => "Betriebszugehörigkeit",
        getValue: ({ employee }) => {
            return (0, utils_1.formatEmployedInterval)(employee.employedInterval);
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    bonuses: {
        preCompile: ({ bonusTypes }) => {
            return bonusTypes.map((bonus) => ({
                type: "bonuses",
                disabled: false,
                bonusId: bonus.id,
            }));
        },
        getHeader: () => "Zuschläge",
        getSubHeader: ({ bonusTypes }, option) => {
            const bonus = bonusTypes.find((b) => b.id === option.bonusId);
            if (!bonus) {
                return "Unbenannter Zuschlag";
            }
            return bonus.name;
        },
        getValue: ({ employee }, option) => {
            var _a;
            const latestBoni = ((_a = employee.latestContract) === null || _a === void 0 ? void 0 : _a.bonuses) || [];
            const bonus = latestBoni.find((bonus) => bonus.typeId === option.bonusId);
            if (!bonus) {
                return "";
            }
            return `${bonus.percent}%`;
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    benefits: {
        preCompile: ({ benefitTypes }) => {
            return benefitTypes.map((benefit) => ({
                type: "benefits",
                disabled: false,
                benefitId: benefit.id,
            }));
        },
        getHeader: () => "Sonderleistungen",
        getSubHeader: ({ benefitTypes }, option) => {
            const benefit = benefitTypes.find((b) => b.id === option.benefitId);
            if (!benefit) {
                return "Unbenannte Sonderleistung";
            }
            return benefit.name;
        },
        getValue: ({ employee }, option) => {
            var _a;
            const latestBenefits = ((_a = employee.latestContract) === null || _a === void 0 ? void 0 : _a.benefits) || [];
            const benefit = latestBenefits.find((benefit) => benefit.typeId === option.benefitId);
            if (!benefit) {
                return "";
            }
            return `${benefit.amount}€`;
        },
        requiredPermissions: ["manage.employees.contract"],
        requiredContext: ["employee"],
    },
    // Time report fields
    timeReportDays: {
        getHeader: () => "Arbeitszeit - Tage",
        getValue({ timeReportAggregate }) {
            return (0, utils_1.formatNumber)((timeReportAggregate === null || timeReportAggregate === void 0 ? void 0 : timeReportAggregate.work.days) || 0);
        },
        requiredPermissions: ["manage.employees.time"],
        requiredContext: ["timeReport"],
    },
    timeReportHours: {
        getHeader: () => "Arbeitszeit - Stunden",
        getValue({ timeReportAggregate }) {
            return (0, utils_1.formatNumber)((timeReportAggregate === null || timeReportAggregate === void 0 ? void 0 : timeReportAggregate.work.hours) || 0);
        },
        requiredPermissions: ["manage.employees.time"],
        requiredContext: ["timeReport"],
    },
    vacationReportDays: {
        getHeader: () => "Urlaubszeit - Tage",
        getValue({ timeReportAggregate }) {
            return (0, utils_1.formatNumber)((timeReportAggregate === null || timeReportAggregate === void 0 ? void 0 : timeReportAggregate.vacation.days) || 0);
        },
        requiredPermissions: ["manage.employees.time"],
        requiredContext: ["timeReport"],
    },
    vacationReportHours: {
        getHeader: () => "Urlaubszeit - Stunden",
        getValue({ timeReportAggregate }) {
            return (0, utils_1.formatNumber)((timeReportAggregate === null || timeReportAggregate === void 0 ? void 0 : timeReportAggregate.vacation.hours) || 0);
        },
        requiredPermissions: ["manage.employees.time"],
        requiredContext: ["timeReport"],
    },
    sickReportDays: {
        getHeader: () => "Krankheit - Tage",
        getValue({ timeReportAggregate }) {
            return (0, utils_1.formatNumber)((timeReportAggregate === null || timeReportAggregate === void 0 ? void 0 : timeReportAggregate.sick.days) || 0);
        },
        requiredPermissions: ["manage.employees.time"],
        requiredContext: ["timeReport"],
    },
    sickReportHours: {
        getHeader: () => "Krankheit - Stunden",
        getValue({ timeReportAggregate }) {
            return (0, utils_1.formatNumber)((timeReportAggregate === null || timeReportAggregate === void 0 ? void 0 : timeReportAggregate.sick.hours) || 0);
        },
        requiredPermissions: ["manage.employees.time"],
    },
    // Employee time balance fields
    timeBalanceCarry: {
        getHeader: () => "Arbeitszeit Übertrag",
        getValue: ({ timeBalance }) => {
            const value = (timeBalance === null || timeBalance === void 0 ? void 0 : timeBalance.reset) || (timeBalance === null || timeBalance === void 0 ? void 0 : timeBalance.carry) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["timeBalance"],
    },
    timeBalanceNominal: {
        getHeader: () => "Arbeitszeit Soll",
        getValue: ({ timeBalance }) => {
            const value = (timeBalance === null || timeBalance === void 0 ? void 0 : timeBalance.nominal) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["timeBalance"],
    },
    timeBalanceActual: {
        getHeader: () => "Arbeitszeit Ist",
        getValue: ({ timeBalance }) => {
            const value = (timeBalance === null || timeBalance === void 0 ? void 0 : timeBalance.actual) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["timeBalance"],
    },
    timeBalanceDifference: {
        getHeader: () => "Arbeitszeit Differenz",
        getValue: ({ timeBalance }) => {
            const value = (timeBalance === null || timeBalance === void 0 ? void 0 : timeBalance.difference) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["timeBalance"],
    },
    timeBalanceBalance: {
        getHeader: () => "Arbeitszeit Saldo",
        getValue: ({ timeBalance }) => {
            const value = (timeBalance === null || timeBalance === void 0 ? void 0 : timeBalance.balance) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["timeBalance"],
    },
    vacationBalanceCarry: {
        getHeader: () => "Urlaub Übertrag",
        getValue: ({ vacationBalance }) => {
            const value = (vacationBalance === null || vacationBalance === void 0 ? void 0 : vacationBalance.reset) || (vacationBalance === null || vacationBalance === void 0 ? void 0 : vacationBalance.carry) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["vacationBalance"],
    },
    vacationBalanceNominal: {
        getHeader: () => "Urlaub Zuwachs",
        getValue: ({ vacationBalance }) => {
            const value = (vacationBalance === null || vacationBalance === void 0 ? void 0 : vacationBalance.nominal) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["vacationBalance"],
    },
    vacationBalanceActual: {
        getHeader: () => "Urlaub Genommen",
        getValue: ({ vacationBalance }) => {
            const value = (vacationBalance === null || vacationBalance === void 0 ? void 0 : vacationBalance.actual) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["vacationBalance"],
    },
    vacationBalanceDifference: {
        getHeader: () => "Urlaub Differenz",
        getValue: ({ vacationBalance }) => {
            const value = (vacationBalance === null || vacationBalance === void 0 ? void 0 : vacationBalance.difference) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["vacationBalance"],
    },
    vacationBalanceBalance: {
        getHeader: () => "Urlaub Saldo",
        getValue: ({ vacationBalance }) => {
            const value = (vacationBalance === null || vacationBalance === void 0 ? void 0 : vacationBalance.balance) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["vacationBalance"],
    },
    bonusesBalanceCarry: {
        getHeader: () => "Bonus Übertrag",
        getValue: ({ bonusesBalance }) => {
            const value = (bonusesBalance === null || bonusesBalance === void 0 ? void 0 : bonusesBalance.reset) || (bonusesBalance === null || bonusesBalance === void 0 ? void 0 : bonusesBalance.carry);
            return value != null ? (0, utils_1.formatNumber)(value) : "N/A";
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["bonusesBalance"],
    },
    bonusesBalanceNominal: {
        getHeader: () => "Bonus Pauschale",
        getValue: ({ bonusesBalance }) => {
            const value = bonusesBalance === null || bonusesBalance === void 0 ? void 0 : bonusesBalance.nominal;
            return value != null ? (0, utils_1.formatNumber)(value) : "N/A";
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["bonusesBalance"],
    },
    bonusesBalanceActual: {
        getHeader: () => "Bonus Verdient",
        getValue: ({ bonusesBalance }) => {
            const value = (bonusesBalance === null || bonusesBalance === void 0 ? void 0 : bonusesBalance.actual) || 0;
            return (0, utils_1.formatNumber)(value);
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["bonusesBalance"],
    },
    bonusesBalanceDifference: {
        getHeader: () => "Bonus Differenz",
        getValue: ({ bonusesBalance }) => {
            const value = bonusesBalance === null || bonusesBalance === void 0 ? void 0 : bonusesBalance.difference;
            return value != null ? (0, utils_1.formatNumber)(value) : "N/A";
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["bonusesBalance"],
    },
    bonusesBalanceBalance: {
        getHeader: () => "Bonus Saldo",
        getValue: ({ bonusesBalance }) => {
            const value = bonusesBalance === null || bonusesBalance === void 0 ? void 0 : bonusesBalance.balance;
            return value != null ? (0, utils_1.formatNumber)(value) : "N/A";
        },
        requiredPermissions: ["manage.employees.ledgers"],
        requiredContext: ["bonusesBalance"],
    },
};
//# sourceMappingURL=config.js.map